import { Picture } from '@emico-react/image'
import cx from 'classnames'

import styles from './HeroImage.module.scss'
import { HighPrioPictureSource } from '../../../presentation/highPrioPicture/HighPrioPictureSource'
import breakpoints from '../../../theme/breakpoints'

interface Props {
    url: string
    mobile_url?: string
    className?: string
}

const HeroImage = ({
    url: image,
    mobile_url: imageMobile,
    className,
}: Props) => (
    <picture>
        {imageMobile && (
            <HighPrioPictureSource
                sizes={{
                    xs: 440,
                    md: 992,
                    lg: 1310,
                    xl: 1800,
                    1800: 2500,
                }}
                url={imageMobile}
                media={image ? '(orientation: portrait)' : ''}
            />
        )}
        {image && (
            <HighPrioPictureSource
                sizes={{
                    xs: 440,
                    md: 992,
                    lg: 1310,
                    xl: 1800,
                    1800: 2500,
                }}
                url={image}
                media={imageMobile ? 'not (orientation: portrait)' : ''}
            />
        )}
        <img
            src=""
            alt=""
            className={cx(styles.imageWrapper, className)}
            // eslint-disable-next-line react/no-unknown-property
            fetchPriority="high"
        />
    </picture>
)

export default HeroImage
